export default {
    shipmentDocumentTypes: [],
    uploadResponse: {}
};
